import _extends from 'babel-runtime/helpers/extends';
import Layout from '@/views/layout/PmLayout';

var layout = function layout() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/project';
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    path: path,
    component: Layout,
    meta: _extends({
      requiresAuth: true,
      permissions: ['project']
    }, meta)
  };
};

export default [_extends({}, layout(), {
  children: [{
    path: 'workbench', // 工作台
    component: function component() {
      return import('@/views/pm/task/index');
    },
    meta: {
      title: '工作台',
      icon: 'workbench'
    }
  }]
}), _extends({}, layout('/project-list'), {
  hidden: true,
  children: [{
    name: 'project-list',
    path: 'project/:id', // 项目
    component: function component() {
      return import('@/views/pm/project/index');
    },
    meta: {
      activeMenu: '/project/list'
    } /** , {
       path: 'index', // 展示用
       meta: {
         title: '项目',
         icon: 'project',
         disabled: true // 禁止next
       }
      }*/ }]
}), _extends({}, layout(), {
  hidden: true,
  children: [{
    path: 'search',
    component: function component() {
      return import('@/views/pm/project/Search');
    },
    meta: {
      title: '搜索',
      activeMenu: '/project/list'
    }
  }]
}), _extends({}, layout(), {
  children: [{
    path: 'list', // 项目封面列表
    component: function component() {
      return import('@/views/pm/project/Corver');
    },
    meta: {
      title: '项目',
      icon: 'project'
    }
  }]
}), _extends({}, layout(), {
  children: [{
    path: 'statistics', // 统计分析
    component: function component() {
      return import('@/views/pm/statistics/index');
    },
    meta: {
      title: '统计分析',
      icon: 'results-solid'
    }
  }]
}), _extends({}, layout(), {
  children: [{
    path: 'archive', // 归档项目
    component: function component() {
      return import('@/views/pm/archive/index');
    },
    meta: {
      title: '归档项目',
      icon: 'archive'
    }
  }]
}), _extends({}, layout('/tag-list'), {
  children: [{
    name: 'tag-list',
    path: 'tag/:id', // 项目
    component: function component() {
      return import('@/views/pm/tag/index');
    },
    hidden: true,
    meta: {
      activeMenu: '/tag-list/index'
    }
  }, {
    path: 'index', // 展示用
    meta: {
      title: '标签',
      icon: 'label',
      disabled: true // 禁止next
    }
  }]
}), _extends({}, layout(), {
  children: [{
    path: 'recycle', // 回收站
    component: function component() {
      return import('@/views/pm/recycle/index');
    },
    meta: {
      title: '回收站',
      icon: 'recycle-bin'
    }
  }]
})];